import { useEffect, useState } from 'react';
import { cx } from 'react-twc';

import { useAuth } from '@/api-hooks/useAuth';
import { useFortune, useFortuneCreate } from '@/api-hooks/useFortune';
import Button from '@/components/v2/Button';
import Image from '@/components/v2/Image';

import styles from './fortune.module.css';
import loader from './loader.module.css';
import { useFortuneFormData, useFortuneStep } from './useFortune';

const FortunePage2 = () => {
  const [, { goToNextStep, goToPrevStep }] = useFortuneStep();
  const [{ shopName, openedAt, category }] = useFortuneFormData();
  const { userId } = useAuth();
  const [isLongLoading, setIsLongLoading] = useState(false);

  const {
    data: fortuneData,
    isError,
    refetch,
  } = useFortune({
    shopName,
    openedAt,
  });

  const { mutateAsync: createFortune, isPending: isCreating } = useFortuneCreate();

  const isSeen = !!fortuneData?.fortuneId;

  const titleText1 = isSeen ? '몽이가 이미 운세를 본 매장이에요!' : '예언가 몽이가 열심히 사장님의';
  const titleText2 = isSeen ? '이전 결과를 불러오는 중' : '미래를 보는 중';
  const tipText = isSeen
    ? '댓글몽 한 달 무료 체험하고 리뷰 관리 간편하게 해보세요!'
    : '20초 동안 마음 속으로 올해 소원을 빌어보세요!';

  useEffect(() => {
    if (!isError) return;
    const fetchData = async () => {
      await createFortune(
        {
          shopName,
          openedAt,
          userId,
          category,
        },
        {
          onSuccess: () => {
            refetch().then(() => {
              goToNextStep();
            });
          },
        },
      );
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError]);

  useEffect(() => {
    if (!fortuneData) return;
    const timeout = setTimeout(() => {
      goToNextStep();
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fortuneData]);

  useEffect(() => {
    // 20초 이상 지나면, 긴 로딩으로 간주, 재시도 + 이탈 가능

    const timer = setTimeout(() => {
      setIsLongLoading(true);
    }, 30000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const back = () => {
    goToPrevStep();
  };

  return (
    <>
      <section
        className={cx(
          'p-4',
          styles.bg,
          'flex flex-col justify-center items-center h-[calc(100%-68px)] py-[200px]',
        )}
      >
        <div>
          <Image src={'/img/fortune/prophet_mong.png'} alt="예언가 몽이" height={248} width={244} />
        </div>
        <p className="text-secondary kcc-ganpan text-[18px] leading-[20px]">{titleText1}</p>
        <div
          className={cx(
            'leading-[40px] kcc-ganpan',
            isSeen ? 'text-[24px]' : 'text-[32px]',
            'flex items-baseline',
          )}
        >
          {titleText2}{' '}
          <div className={loader.wrapper}>
            <div className={loader.circle} />
            <div className={loader.circle} />
            <div className={loader.circle} />
            <div className={loader.shadow} />
            <div className={loader.shadow} />
            <div className={loader.shadow} />
          </div>
        </div>
        {isLongLoading && (
          <div className="mt-4">
            <p className="text-[14px] text-white font-bold text-center">
              지나치게 오래 걸리고 있나요?{' '}
            </p>

            <div className="flex gap-4 mt-2">
              <Button variant={'tonalgray'} onClick={back}>
                뒤로가기
              </Button>

              <Button
                variant={'gray'}
                loading={isCreating}
                onClick={async () =>
                  await createFortune(
                    {
                      shopName,
                      openedAt,
                    },
                    {
                      onSuccess: () => {
                        refetch().then(() => {
                          goToNextStep();
                        });
                      },
                    },
                  )
                }
              >
                다시 불러오기
              </Button>
            </div>
          </div>
        )}
        <div className="mt-8">
          <Image src={'/img/fortune/tip.png'} width={38} height={33} alt="Tip" />
        </div>
        <p className="font-medium text-[14px] text-black mt-2">{tipText}</p>
      </section>
    </>
  );
};

export default FortunePage2;
